var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMenuNavbar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4737 23.1561H2.52628C1.88615 23.1561 1.36725 22.6372 1.36725 21.997V9.11035H22.6327V21.997C22.6327 22.6372 22.1138 23.1561 21.4737 23.1561Z",
    fill: "#1062D0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.184 9.11035V21.997C21.184 22.6372 20.6652 23.1561 20.0251 23.1561H21.4738C22.1138 23.1561 22.6327 22.6371 22.6327 21.997V9.11035H21.184Z",
    fill: "#1976D2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.84375V9.11053H6L6.64866 0.84375H12Z",
    fill: "#3344A5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.64866 0.84375L6 9.11053H0L1.07053 1.83412C1.1542 1.26525 1.64222 0.84375 2.21714 0.84375H6.64866Z",
    fill: "#73A3EC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.84375V9.11053H18L17.3513 0.84375H12Z",
    fill: "#73A3EC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3513 0.84375L18 9.11053H24L22.9294 1.83412C22.8458 1.26525 22.3578 0.84375 21.7828 0.84375H17.3513Z",
    fill: "#3344A5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9294 1.83412C22.8458 1.26525 22.3578 0.84375 21.7828 0.84375H20.3342C20.9091 0.84375 21.3971 1.26525 21.4808 1.83412L22.5513 9.11053H24L22.9294 1.83412Z",
    fill: "#313F97"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.00066 12.2152H2.99939C1.34288 12.2152 0 10.8723 0 9.21582V9.11035H6V9.21582C6 10.8723 4.65712 12.2152 3.00066 12.2152Z",
    fill: "#5D96EC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00067 12.2152H8.9994C7.34289 12.2152 6.00006 10.8723 6.00006 9.21582V9.11035H12.0001V9.21582C12 10.8723 10.6571 12.2152 9.00067 12.2152Z",
    fill: "#313F97"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0007 12.2152H14.9994C13.3429 12.2152 12.0001 10.8723 12.0001 9.21582V9.11035H18.0001V9.21582C18 10.8723 16.6571 12.2152 15.0007 12.2152Z",
    fill: "#5D96EC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0007 12.2152H20.9994C19.3429 12.2152 18.0001 10.8723 18.0001 9.21582V9.11035H24.0001V9.21582C24 10.8723 22.6571 12.2152 21.0007 12.2152Z",
    fill: "#313F97"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5513 9.11035V9.21568C22.5513 10.6227 21.5825 11.8029 20.2757 12.1268C20.5075 12.1842 20.7497 12.2153 20.9992 12.2153H21.0009C22.6573 12.2153 24.0001 10.8723 24.0001 9.21573V9.1104H22.5513V9.11035Z",
    fill: "#303F9F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuNavbar);
export default __webpack_public_path__ + "static/media/icon-menu-navbar.73c99fb211984961d284d57006f0b8ee.svg";
export { ForwardRef as ReactComponent };